import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { sortSearchParam } from '@/components/data-table/tableSort';
import { monthSearchParam } from '@/features/timesheet/model/searchParams';
import { SummaryPage } from '@/features/timesheet/summary/SummaryPage';

export const Route = createFileRoute('/_authenticated/attendance/summary')({
  validateSearch: z.object({
    month: monthSearchParam,
    by: z.enum(['person', 'project']).optional(),
    project: z.array(z.string()).optional(),
    person: z.array(z.string()).optional(),
    s: sortSearchParam,
  }),
  component: function AttendanceSummary() {
    const { month, by, project, person, s } = Route.useSearch();
    return <SummaryPage month={month} by={by ?? 'person'} project={project} person={person} s={s} />;
  },
});
